<template>
	<div style="padding-top : 70px;">
		<div v-if="loading" class="engage-loader">
			<div class="engage-loader__spinner"></div>
			<h3 class="engage-loader__text">Loading...</h3>
		</div>
		<div v-else-if="error" class="engage-error">
			<div class="engage-error__icon">
				<font-awesome-icon
					:icon="['fal', 'exclamation-triangle']"
					size="4x"
					style="color: #dc3545;"
				/>
			</div>
			<h3 class="engage-error__title">
				Dashboard Temporarily Unavailable
			</h3>
		</div>
		<iframe
			v-else
			:src="flowLineURLSrc"
			width="100%"
			max-width="1400px"
			min-height="1000px"
			style="height: 100%"
		></iframe>
	</div>
</template>

<script>
import { mapGetters, mapState, mapActions } from 'vuex'

export default {
	computed: {
		flowLineURLSrc() {
			return this.engage?.url ? atob(this.engage.url) : ''
		},

		...mapGetters({
			// partners module
			active: 'partners/active',
			isEngageApp: 'partners/isEngageApp',
			clarusAppType: 'partners/clarusAppType',
			isOnlyEngageApp: 'partners/isOnlyEngageApp',

			// engage module
			loading: 'engage/loading',
			error: 'engage/error',
		}),

		...mapState({
			engage: state => state.engage.engageProperties,
		}),
	},

	methods: {
		...mapActions('engage', ['getEngage']),
	},

	name: 'Engage',

	watch: {
		isEngageApp: {
			handler(hasAccess) {
				if (!hasAccess) {
					if (this.clarusAppType) {
						this.$router.push({ name: 'app.calls' })
					} else if (this.isOnlyEngageApp) {
						this.$router.push({ name: 'app.fallback' })
					}
				}
			},
			immediate: true,
		},
		$route(to, from) {
			const partnerChanged = to.params.partner !== from.params.partner
			if (partnerChanged && !this.isEngageApp && this.clarusAppType) {
				this.$router.push({ name: 'app.calls' })
			} else if (
				partnerChanged &&
				this.isOnlyEngageApp &&
				!this.clarusAppType &&
				!this.isEngageApp
			) {
				this.$router.push({ name: 'app.fallback' })
			}
		},
		active: {
			handler(newPartner, oldPartner) {
				const newPartnerId = newPartner?.id
				const oldPartnerId = oldPartner?.id
				if (newPartnerId && newPartnerId !== oldPartnerId) {
					this.getEngage()
				}
			},
			immediate: true,
		},

		'engage.expiry': {
			handler(newExpiry) {
				// newExpiry is in hours, call 1 hour before expiry
				const delay = (newExpiry - 1) * 60 * 60 * 1000
				if (delay > 0) {
					setTimeout(() => {
						this.getEngage()
					}, delay)
				}
			},
		},
	},
}
</script>
